"use strict";

var $ = require("jquery");

$(document).ready(function () {

    if($('.button').hasClass('wp-element-button')){
        $('.button').removeClass('wp-element-button');
    }

});